(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/start-info-section/start-info-section.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/start-info-section/start-info-section.js');
'use strict';

const {
  ReactCard: {
    Card,
    CardBody,
    CardGroup
  },
  Button,
  ReactIcon
} = svs.ui;
const {
  grassrootsQueryApi
} = svs.grassroots.store;
const {
  baseUrl
} = svs.core.data;
const Counter = _ref => {
  let {
    data
  } = _ref;
  const ref = React.useRef();
  const {
    countNumbers: {
      countNumbers,
      setCountNumbers
    }
  } = React.useContext(svs.grassroots.context.Context);
  const [value, setValue] = React.useState(data);

  React.useEffect(() => {
    if (countNumbers) {
      setValue(0);
      gsap.to(ref.current, {
        innerText: value,
        duration: 2,
        ease: 'power1.inOut',
        stagger: 0.1,
        modifiers: {
          innerText: innerText => gsap.utils.snap(1, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        }
      });
      setCountNumbers(false);
    }
  }, []);
  return React.createElement("h2", {
    className: "grassroots-start-info-counter-number",
    ref: ref
  }, value.toLocaleString('sv-SE'));
};
const onClickLoginAndSearch = e => {
  e && e.preventDefault();
  svs.components.customer_login.login({
    returnUrl: "".concat(svs.core.data.baseUrl, "/sok")
  });
};
const StartInfoSection = () => {
  const {
    data
  } = grassrootsQueryApi.useFetchStatisticsQuery();
  return React.createElement("div", {
    className: "grassroots-start-info-background-container"
  }, React.createElement("div", {
    className: "grassroots-start-info-container"
  }, React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "align-center grassroots-start-info-card-container"
  }, React.createElement(CardBody, null, React.createElement("h1", null, svs.grassroots_shared_2.data.config.title), React.createElement("p", null, svs.grassroots_shared_2.data.config.ingress), React.createElement("div", {
    className: "grid-row grassroots-start-info-counter-container"
  }, React.createElement("div", {
    className: "col-xs-12 col-sm-6"
  }, (data === null || data === void 0 ? void 0 : data.receiverCount) && React.createElement("div", null, React.createElement(Counter, {
    data: data.receiverCount
  }), React.createElement("h3", {
    className: "f-medium grassroots-start-info-counter-type"
  }, svs.grassroots_shared_2.data.config.receivers))), React.createElement("div", {
    className: "col-xs-12 col-sm-6"
  }, (data === null || data === void 0 ? void 0 : data.supporterCount) && React.createElement("div", null, React.createElement(Counter, {
    data: data.supporterCount
  }), React.createElement("h3", {
    className: "f-medium grassroots-start-info-counter-type"
  }, svs.grassroots_shared_2.data.config.supporters))), React.createElement("div", {
    className: "col-xs-12"
  }, !svs.grassroots_shared_2.data.config.isCorporateSite && React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    iconPosition: "right",
    inverted: true,
    onClick: onClickLoginAndSearch
  }, "St\xF6tta din f\xF6rening"))))), svs.grassroots_shared_2.data.config.isCorporateSite && React.createElement(CardGroup, {
    className: "grassroots-start-info-corporate-container align-center"
  }, React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "padding-1 grassroots-start-info-corporate-marketing"
  }, React.createElement(CardBody, {
    className: "u-flex u-flex-column"
  }, React.createElement("h3", {
    className: "grassroots-start-info-corporate-marketing-title"
  }, svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing.marketing.title), React.createElement("p", null, svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing.marketing.description), React.createElement(Button, {
    block: true,
    className: "grassroots-start-info-corporate-button",
    href: svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing.marketing.buttonPath,
    iconPosition: "right",
    inverted: true
  }, React.createElement(ReactIcon, {
    icon: "link-external"
  }), ' ', svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing.marketing.buttonText))), React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "padding-1 grassroots-start-info-corporate-supporter"
  }, React.createElement(CardBody, {
    className: "u-flex u-flex-column"
  }, React.createElement("h3", {
    className: "grassroots-start-info-corporate-supporter-title"
  }, svs.grassroots_shared_2.data.config.grassrootsSupporter.supporter.title), React.createElement("p", null, svs.grassroots_shared_2.data.config.grassrootsSupporter.supporter.description), React.createElement(Button, {
    block: true,
    className: "grassroots-start-info-corporate-button",
    href: baseUrl + svs.grassroots_shared_2.data.config.grassrootsSupporter.supporter.buttonPath,
    inverted: true
  }, svs.grassroots_shared_2.data.config.grassrootsSupporter.supporter.buttonText))))));
};
svs.grassroots.components.start_info_section.StartInfoSection = StartInfoSection;

 })(window);